import { render } from "./App.vue?vue&type=template&id=4d88d202"
const script = {}

import "./App.vue?vue&type=style&index=0&id=4d88d202&lang=css"

import exportComponent from "/home/runner/work/jdtree-ui/jdtree-ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__